module.exports = __webpack_public_path__ + "static/media/dropdown_arrow.86cad403.png";